module.exports = {"version":"4.1.10"}


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 231
// module chunks = 1